var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchandise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0625 1.28713C7.2351 1.28713 7.375 1.42704 7.375 1.59963V7.53713C7.375 7.70971 7.2351 7.84963 7.0625 7.84963H1.125C0.952402 7.84963 0.8125 7.70971 0.8125 7.53713V1.59963C0.8125 1.42704 0.952402 1.28713 1.125 1.28713H7.0625ZM6.04688 2.61526H2.14062V6.52151H6.04688V2.61526ZM15.6823 4.32788C15.8043 4.44991 15.8043 4.64778 15.6823 4.76981L12.1467 8.30536C12.0247 8.42739 11.8269 8.42739 11.7048 8.30536L8.16928 4.76981C8.04725 4.64778 8.04725 4.44991 8.16928 4.32788L11.7048 0.792329C11.8269 0.670298 12.0247 0.670298 12.1468 0.792329L15.6823 4.32788ZM14.025 4.54883L11.9258 2.44963L9.82656 4.54885L11.9258 6.64807L14.025 4.54883ZM7.0625 9.09963C7.2351 9.09963 7.375 9.23956 7.375 9.41213V15.3496C7.375 15.5222 7.2351 15.6621 7.0625 15.6621H1.125C0.952402 15.6621 0.8125 15.5222 0.8125 15.3496V9.41213C0.8125 9.23956 0.952402 9.09963 1.125 9.09963H7.0625ZM6.04688 10.4278H2.14062V14.334H6.04688V10.4278ZM14.875 9.09963C15.0476 9.09963 15.1875 9.23956 15.1875 9.41213V15.3496C15.1875 15.5222 15.0476 15.6621 14.875 15.6621H8.9375C8.7649 15.6621 8.625 15.5222 8.625 15.3496V9.41213C8.625 9.23956 8.7649 9.09963 8.9375 9.09963H14.875ZM13.8594 10.4278H9.95312V14.334H13.8594V10.4278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchandise);
export default __webpack_public_path__ + "static/media/merchandise.39516d6f11e41a1f56a972080aaba1a6.svg";
export { ForwardRef as ReactComponent };